
const SessionContext = {
  setUserContext: function (userContext) {
    sessionStorage.setItem('userContext', JSON.stringify(userContext))
  },
  getUserContext: function () {
    let userContextStr = sessionStorage.getItem('userContext')
    if (userContextStr && userContextStr !== '') {
      return JSON.parse(userContextStr)
    }
    return {}
  },
  clearUserContext: function () {
    sessionStorage.removeItem('userContext')
  }
}

export default SessionContext



// WEBPACK FOOTER //
// ./src/assets/js/sessionContext.js